import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { terminateContract } from 'features/users(Employees)/usersSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch } from 'store'
import { Button } from 'components/ui/Button/Button'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { ITerminateContractPostRequest } from 'types/api/usersApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const TerminateContractModal = ({ closeModal, fromUserPage, id }: { closeModal: any, fromUserPage?: boolean, id: number }) => {
    const [state, setState] = useState<ITerminateContractPostRequest>({ terminationDate: null, reason: null })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        if (!state.terminationDate) {
            toast.warn('Termination date must be selected')
        }
        const resp = await dispatch(terminateContract({ id, data: state, fromUserPage }))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Terminate Contract</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <CalendarInput nomarg minDate={new Date()} labelText='Termination Date' required onChange={v => setState(prev => ({ ...prev, terminationDate: v }))} />
                <Input height='100px' type='textarea' placeholder='Enter termination reason' labelText='Reason' value={state.reason} onChange={e => setState(prev => ({ ...prev, reason: e.target.value }))} />
            </Flex>
            <Button disabled={!state.terminationDate} variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}